<script lang="ts">
/*
Edit User screen-
To change name, delete user (+ all info)
Maybe int he future change user icon?
*/

import CategoryData, { CatDB } from '@/ts/DataTypes/CategoryData';
import Data from '@/ts/Data';
import { defineComponent, nextTick } from 'vue'
import Category from './Category.vue';

import StaticVars, { ModalInfo } from '@/ts/StaticVars';
import Entry, { EntryDB } from '@/ts/DataTypes/Entry';
import { db, UserDB} from '../ts/DexieDB';
import InputTextSmart from './InputTextSmart.vue';
import ButtonVue from './Button.vue';
import {ButtonInfo} from './ButtonGroup.vue';
import ButtonGroup from './ButtonGroup.vue';
import EntryEditable from './EntryEditable.vue';

import MaterialIconsList from '../ts/MaterialIconsList';

export default defineComponent({
    components: { InputTextSmart, ButtonVue, EntryEditable, ButtonGroup },
    props: {
        //have to have this as a variable in the router/index.ts to actually get it: /:category
        //and can't share data- only strings between components if using vue router

        ReloadPage: { type: Function, required:true },

        BackButtonRegister: { type: Function, required:true },
        MoveForwardToPage: { type: Function, required:true },
        MoveBack: { type: Function, required:true },// switch screen, but just for moving back


        category: { type: String },
        extra: { type: Object, default: {} },
        // user:{type:UserDB, required:true},
        ShowModal:{ type:Function, required:true},//have to give it a default value, or typescript thinks it could be undefined...,
        // user:{type:UserDB, required:true},
        AddOrEditCat:{ type:Function, required:true},
        CategoryDelete:{ type:Function, required:true},

    },
    data() 
    {
        return {
          entry:(new Entry({blank:true})),
          extra_info:({}),
          loaded:false,
          cat:({} as CategoryData),
          new_cat:false,
          last_screen:StaticVars.SCREENS.HOME,
          keyword_search:"",
          icons_for_search:new Array<ButtonInfo>(),
          color_bg:"rgba(128,128,128,1)",
          color_txt:"rgba(255,255,255,1)",
          text:"",//New Category Name
          icon_selected:"paragliding",
          cat_changed:false, //for whether to update the previous screen if a cat has changed/ created

        };
    },
    mounted() 
    {
        this.BackButtonRegister(this.Back);

        console.log("cat edit screen mounted ! extra:", this.extra);
        let extra_info = (this.extra as any);
        this.cat = extra_info.cat;

        if(extra_info.last_screen)
            this.last_screen=extra_info.last_screen;

        console.log("cat last_screen", this.last_screen);
        console.log("cat edit screen mounted this.cat:", this.cat);

        if(!this.cat)
        {
            console.log("cat edit screen, creating new cat");
            //create a new blank cat
            this.new_cat=true;
            this.cat = new CategoryData({name:"New Category Name"});
        }
        else
        {
            
            this.cat = new CategoryData({...extra_info.cat});

            //to keep the updated/ timestamp the same for identifying in database/ updating
            this.cat.timestamp=extra_info.cat.timestamp;
            // this.cat.date_updated=extra_info.cat.date_updated; //want to update the updated time
            this.cat.date_updated = new Date();
            console.log("cat edit screen, using existing cat date updated: ",this.cat.date_updated );

            this.text=this.cat.name;
            this.color_bg=this.cat.color_bg;
            this.color_txt=this.cat.color_txt;
            this.icon_selected=this.cat.icon;
            
            //have to populate the fields here
        }
        let icons = MaterialIconsList.GetIcons(0, 10);
        console.log("cat edit screen mounted ! user:", this.cat);
        console.log("First 10 icons: ", icons)
       this.loaded=true;
       
       
       console.log("initializing jscolor");
       //initialize color pickers
       
       this.$nextTick(()=>{
        //@ts-ignore
       jscolor.install() // recognizes new inputs and installs jscolor on them


       let jscolor_bg = (this.$refs.jscolor_background as any).jscolor;
       jscolor_bg.fromString(this.color_bg);
       console.log("jscolor mounted: ", jscolor_bg);
    //    jscolor_bg.onChange = ()=>{this.ChangeBGColor(jscolor_bg.toRGBAString())};
        jscolor_bg.onInput = ()=>{this.ChangeBGColor(jscolor_bg.toRGBAString())};
        
 
       let jscolor_txt = (this.$refs.jscolor_txt as any).jscolor;
       jscolor_txt.fromString(this.color_txt);
       jscolor_txt.onInput = ()=>{this.ChangeTXTColor(jscolor_txt.toRGBAString())};
       

       });
    },
    computed: 
    {
       
    },
    methods: 
    {
        //switch screen will be passed in from App
        Back(SwitchScreen:Function)
        {
            //should also refresh screen if added/ edited category
            console.log("Cateditscreen: switch screen, this cat: ", this.cat);
            
            //need to have the app call history.back();, instead of actually calling this
            SwitchScreen(this.last_screen, {cat_changed:this.cat_changed, cat:{...this.cat}/* , test:"testy mc test" */});

            // history.back();
        },
        async UpdateCat()
        {
            let name = (this.$refs.cat_name as typeof InputTextSmart).GetText();
            if(!name)
            {
                let modal_info = new ModalInfo({text: `The category name must not be blank`, only_one_btn:true});
                this.ShowModal(modal_info); 
            }
            else
            {
                
                // let icon_name = this.$refs.icon_name;
                
                
                this.cat.Assign({name:name, color_bg:this.color_bg, color_txt:this.color_txt, icon:this.icon_selected, })

                //update or creat cat
                this.cat_changed=true;
                if(this.new_cat)
                {                    
                    console.log("Creating new cat: ", this.cat);
                    this.cat = await this.AddOrEditCat(this.cat);
                    let modal_info = new ModalInfo({text: `New Category '${this.cat.name}' created! Returning to previous screen`, callback_yes:()=>{history.back();}, only_one_btn:true});
                    this.ShowModal(modal_info);
                }
                else
                {
                    console.log("Updating cat: ", this.cat);
                    await this.AddOrEditCat(new CatDB(this.cat));
                    //should also update this cat in Data
                    let modal_info = new ModalInfo({text: `Category '${this.cat.name}' updated! Returning to previous screen`, callback_yes:()=>{history.back();}, only_one_btn:true});
                    this.ShowModal(modal_info);
                }

                // let new_cat = new CatDB();

                


                // (this.user as any).name = name;
                // let user_updated = new UserDB(this.user)
                // console.log("updating user to: ", user_updated)
                // await Data.UpdateUser(user_updated);
                

                // this.ShowModal({text: `User name changed to ${this.user.name}`, callback_yes: this.Back, only_one_btn:true});
            }
        },
        DeleteCat()
        {
            this.ShowModal({text: `Delete Category ${this.cat.name} and all data for good? `, callback_yes: ()=>{this.CategoryDelete(this.cat);history.back();}});

        },
        /* async DeleteCatForReal()
        {
            // console.log("deleting user for real", this.user);
            // console.log("need to actually delete user and all related data");
            // await Data.DeleteUser(this.user);
            // await nextTick()
            // await nextTick()
            // this.ShowModal({text: `User ${this.user.name} and all their associated data deleted. Reloading app...`, callback_yes: this.ReloadPage, only_one_btn:true});
            //need to also reload the app
        }, */
        async SearchForIcon()
        {
            console.log("SearchForIcon, ", this.keyword_search, this.keyword_search);
            if(this.keyword_search)
            {
                let icons = await MaterialIconsList.GetIconsByTag(this.keyword_search);
                console.log("icons: ", icons);
                // this.icons_for_search=icons;
                let icons_temp=new Array<ButtonInfo>();
                // for (const icon of icons) 
                let max_icons=30;//for safety/ infinite loops with 3k icons

                for( let i=0; i<icons.length;i++)
                {               
                    let icon = icons[i];
                    // if(icons_temp.length<200)     
                        icons_temp.push(new ButtonInfo({text:"", icon:icon, color_bg:"blue", 
                                                        color_txt:"white",
                                                        fontsize_icon:"60px",
                                                        extra_info:{name:icon/* , date_updated:cat.date_updated */}}));       
                    
                    if(icons_temp.length>max_icons)     
                    {
                        console.warn("number of icons exceeds "+max_icons+"!!! breaking out");
                        break;
                    }
                }
                if(icons_temp.length>0)
                {
                    this.icons_for_search = icons_temp;
                    console.log("icons_for_search: ", this.icons_for_search);
                }

                //btn_info.push(new ButtonInfo({text:cat.name, icon:cat.icon, bg_color:cat.bg_color, txt_color:cat.txt_color, extra_info:{id_cat:cat.id/* , date_updated:cat.date_updated */}}));            

                //now have to create smart buttons for it... need to have name of icon + actual icon
            }
        },
        IconSelected(extra_info:any)
        {
            console.log("an icon has been selected, now to do something with it", extra_info);
            this.icon_selected=extra_info.icon;
        },
        ChangeBGColor(color:string)
        {
            // console.log("Bg color changed to: ",color);
            this.color_bg=color;
        },
        ChangeTXTColor(color:string)
        {
            console.log("TXT color changed to: ",color);
            this.color_txt=color;
        },
        ChangeText(text_new:string)
        {
            // console.log("changed text to ", text_new);
            this.text=text_new;

        },
        HistoryBack(){history.back();/*this.Back(MoveBack)*/}
        
    },
    
});
</script>

<template>

    <div class="container" v-if="loaded">
        <!-- <script>
            UpdateJSColor(data)
            {
                console.log("Updated JS color!!!", data);
            }
        </script> -->

        <!-- So for editing or creating a Category.
        Need to have:
        * Edit the name of it
        * Edit the background color
        * Text color
        * icon
        -->
        <!-- <input type="text" :value="text" placeholder="Enter Category Name" ref="cat_name" @input="(event)=>{ChangeText((event as any).target.value)}"/> -->
        <InputTextSmart 
        :default_value="text" 
        placeholder="Enter Category Name" 
        ref="cat_name" 
        :TextChanged="ChangeText" 
        :show_submit_btn="false"/>

        <div>
            <span>Category Button Preview: </span>
            <ButtonVue :text="text" :color_bg="color_bg" :color_txt="color_txt" :icon="icon_selected"/>
        </div>

        <!-- <input value="rgba(255,160,0,0.5)" data-jscolor="{
        position: 'right', width: 181, height: 181,
        padding: 10, sliderSize: 25, borderRadius: 5,
        borderWidth: 1, controlBorderWidth: 1, pointerBorderWidth: 2,
        borderColor: '#000', controlBorderColor: '#CCC', backgroundColor: '#333',
        onChange: 'update(this, \'#pr1\')',
            onInput: 'update(this, \'#pr2\')',
        }"> -->
        <!-- <input data-jscolor="{}" value="#3399FF"> -->
        <div class="color-picker-wrapper">
            <span>Background Color:</span>
            <button class="color-picker-btn" data-jscolor="{
            alpha:1.0, value:'CCFFAA',
            position: 'bottom', width: 181, height: 181,
            padding: 10, sliderSize: 25, borderRadius: 5,
            borderWidth: 1, controlBorderWidth: 1, pointerBorderWidth: 2,
            borderColor: '#000', controlBorderColor: '#CCC', backgroundColor: '#333',
        }"
        ref="jscolor_background"></button>
        </div>
        <div class="color-picker-wrapper">
            <span>Text Color:</span>
            <button class="color-picker-btn" data-jscolor="{
            alpha:1.0, value:'CCFFAA',
            position: 'bottom', width: 181, height: 181,
            padding: 10, sliderSize: 25, borderRadius: 5,
            borderWidth: 1, controlBorderWidth: 1, pointerBorderWidth: 2,
            borderColor: '#000', controlBorderColor: '#CCC', backgroundColor: '#333',
        }"
        ref="jscolor_txt"></button>
        </div>

        <h1>Search for Icon</h1>
        <input type="text"  placeholder="Type in keyword" ref="icon_name" @input="SearchForIcon" v-model="keyword_search"/>
        <!-- Should show a list of icons that contain that tag- have to use a partial auto complete to look through tags -->

        <div style="height:500px; overflow-y: auto;">
            <!-- <ButtonVue v-for="icon in icons_for_search" :text="icon" :icon="icon"/> -->
            <!-- <p  v-for="icon in icons_for_search">{{icon}}</p> -->


            <ButtonGroup :button_info="icons_for_search" :Changed="IconSelected" ref="cats_ui"/>

        </div>


        <ButtonVue :text="new_cat?'Create Category':'Update Category'" type="yes" :callback="UpdateCat"/>
        <ButtonVue v-if="!new_cat" text="Delete Category" type="no" :callback="DeleteCat"/>

        
        

    </div>
    <!-- <ButtonVue text="" class="back" type="back" :callback="()=>{Back(MoveBack)}"/> -->
        <ButtonVue text="" class="back" type="back" :callback="()=>{ HistoryBack()}"/>
</template>

<style scoped>
.container
{
    display: flex;
    width:100%;
    gap:10px;
    flex-direction: column;
    margin-top:10px;
    /* align-content: flex-start; */
    position: relative;

    /* For bottom button*/
    height: calc(-65px + 100vh);
    overflow-y: auto;
    scrollbar-width: thin;
}
.back
{
    display:block;
    width:calc(100% - 20px);
}
.color-picker-wrapper
{
    display: flex;
    align-items: center;
    justify-content: stretch;
    gap:10px;
}
.color-picker-btn
{
    width:50px;
    aspect-ratio: 1;
}

</style>